import React from 'react';

const ItemIcon = ({ itemIconLabel }) => {
  return <span className='itemIcon'>{itemIconLabel}</span>;
};

export default ItemIcon;



// WEBPACK FOOTER //
// ./src/components/ItemIcon.jsx